export default {
  navigationDrawer: state => state.navigationDrawer,
  exporters: state => state.exporters,
  timePeriods: state => state.timePeriods,
  account: state => state.account
};
